import { get, post } from '../index'

export default {
  /**
   * Management company info
   */
  registry: (body) => post('/companys', body, { headers: { isPublic: true } }),
  checkInforma: (nif, promotercode) => get(`/informa/companies/${nif}/promoters/${promotercode}`, { headers: { isPublic: true } }),
  subscription: (body, promoter) => post(`/companys/subscriptions/promoters/${promoter}`, body, { headers: { isPublic: true } })
}
